export default "__VITE_ASSET__CTi2oiMu__"